import { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getVehicleIdFromStockNumber } from '|/app/guided-flow/services';
import AppFrameworkContext from '|/helpers/app-framework';

const useGuidedFlowVm = () => {
  const { search } = useLocation();
  const { load } = useContext(AppFrameworkContext);
  const [newRoute, setNewRoute] = useState<null | string>(null);

  useEffect(() => {
    const searchParams = new URLSearchParams(search);

    const stockNumberNumber = parseInt(searchParams.get('stock-number') || '');
    const stockNumber = Number.isNaN(stockNumberNumber)
      ? null
      : stockNumberNumber;

    if (stockNumber !== null) {
      load(
        getVehicleIdFromStockNumber(`${stockNumber}`).then(vehicleId => {
          setNewRoute(`/?vehicle-id=${vehicleId}`);
        })
      );
      return;
    }

    const vehicleIdNumber = parseInt(searchParams.get('vehicle-id') || '');
    const vehicleId = Number.isNaN(vehicleIdNumber) ? null : vehicleIdNumber;

    if (vehicleId !== null) {
      setNewRoute(`/vehicle/${vehicleId}`);
      return;
    }

    setNewRoute('/next-step');
  }, [load, search]);

  return newRoute;
};

export default useGuidedFlowVm;
